<template>
  <div class="bar-chart-scroll">
    <div class="bar-chart-container">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  name: 'ApiErrorsByDateBarChart',
  props: {
    apiErrors: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateChart() {
      const counts = {};

      this.apiErrors.forEach(error => {
        const date = new Date(error.created_at).toLocaleDateString('pt-BR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        counts[date] = (counts[date] || 0) + 1;
      });

      const labels = Object.keys(counts);
      const data = Object.values(counts);

      this.renderChart(
        {
          labels,
          datasets: [
            {
              label: 'Total',
              backgroundColor: '#42a5f5',
              data,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: {
              fontSize: 12,
            },
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  autoSkip: false,
                  fontSize: 12,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  fontSize: 12,
                },
              },
            ],
          },
        }
      );
    },
  },
  watch: {
    apiErrors: {
      immediate: true,
      handler() {
        if (this.apiErrors.length > 0) this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.bar-chart-scroll {
  overflow-x: auto;
  width: 100%;
}

.bar-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
  min-width: 600px;
}
</style>
